module.exports = __webpack_public_path__ + "img/about-us@x1.a11c1bd1.png";